import type { SpotlightProps } from '@atlaskit/onboarding/types';

export const target = (value?: string): string => {
	if (!value || value.length === 0) {
		return '';
	}

	/**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * . — class selector
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */
	return value.replaceAll(' ', '-').replaceAll('/', '-');
};

const placementMap = {
	'top right': 'top-start',
	'top center': 'top-center',
	'top left': 'top-end',
	'right bottom': 'right-start',
	'right middle': 'right-start',
	'right top': 'right-end',
	'bottom left': 'bottom-end',
	'bottom center': 'bottom-center',
	'bottom right': 'bottom-start',
	'left top': 'left-end',
	'left middle': 'left-start',
	'left bottom': 'left-start',
} as const;

export const dialogPlacement = (value: SpotlightProps['dialogPlacement']): "top-start" | "top-center" | "top-end" | "right-start" | "right-end" | "bottom-end" | "bottom-center" | "bottom-start" | "left-end" | "left-start" => {
	// `bottom left` is the default placement when `undefined` is passed.
	return placementMap[value || 'bottom left'];
};

export const translations: { target: (value?: string) => string; dialogPlacement: (value: SpotlightProps["dialogPlacement"]) => "top-start" | "top-center" | "top-end" | "right-start" | "right-end" | "bottom-end" | "bottom-center" | "bottom-start" | "left-end" | "left-start"; } = {
	target,
	dialogPlacement,
};
